import { render, staticRenderFns } from "./AddTaskRecord.vue?vue&type=template&id=04e02ad2&scoped=true"
import script from "./AddTaskRecord.vue?vue&type=script&lang=js"
export * from "./AddTaskRecord.vue?vue&type=script&lang=js"
import style0 from "./AddTaskRecord.vue?vue&type=style&index=0&id=04e02ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e02ad2",
  null
  
)

export default component.exports